import { useMutation, useQuery } from '@tanstack/react-query';
import { performAuthorization } from '../api/performAuthorization';

export function useAuthorization() {
  const query = useQuery({
    queryKey: ['tokens'],
    queryFn: () => ({}),
  });

  const mutation = useMutation({
    mutationFn: performAuthorization,
    onSuccess: ({ refresh, jwt }) => {
      localStorage.setItem('token', jwt as string);
      localStorage.setItem('refresh', refresh);
    },
  });

  return {
    tokens: query.data,
    authorize: mutation.mutateAsync,
    isAuthorizationInProgress: mutation.isPending,
  };
}
